import { gql } from '@apollo/client'

const UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS_MUTATION = gql`
  mutation updateDishTypeAlternativeIngredientsDetails(
    $id: ID!
    $data: [DishTypeAlternativeIngredientDetailsInput!]!
  ) {
    updateDishTypeAlternativeIngredientsDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      alternativeIngredients {
        ingredientId
        alternativeIngredientId
        notes
      }
    }
  }
`

export default UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS_MUTATION
